import ReviewsCarousel from './ReviewsCarousel';
import ReviewAuthor from './ReviewAuthor';
import { digitalTrendsCover, mobileRoiCover, seoTop3Cover } from './articleCovers';
import { useState } from 'react';

import { RedesignFooter, RedesignHeader, RedesignPage, SiteLink } from './RedesignShell';
import LeadForm from './LeadForm';
import PageMeta from './PageMeta';
import TelStoreCover from './TelStoreCover';
import GeographyMap from './GeographyMap';

const services = [
  {
    href: '/services/websites/',
    number: '01 / разработка',
    title: 'Создание сайтов',
    description:
      'Разрабатываем эффективные сайты — от продающих лендингов и интернет-магазинов до корпоративных порталов. Создаем веб-решения, которые приносят результат.',
    meta: 'лендинги · корп. сайты · e-commerce',
  },
  {
    href: '/services/mobile/',
    number: '02 / мобайл',
    title: 'Мобильные приложения',
    description:
      'Создаем современные приложения для iOS и Android. Реализуем проекты от концепции до публикации в магазинах приложений.',
    meta: 'ios · android · react native',
  },
  {
    href: '/services/mini-apps/',
    number: '03 / mini apps',
    title: 'Мини-приложения для Telegram',
    description:
      'Разрабатываем функциональные мини-приложения ( MIni App) для Telegram. Эффективные решения для вовлечения аудитории, автоматизации продаж и увеличения конверсии.',
    meta: 'tg mini app · vk · max · боты',
  },
  {
    href: '/services/seo/',
    number: '04 / seo',
    title: 'SEO-продвижение',
    description:
      'Комплексное продвижение: SEO, контекстная реклама, работа с коммерческими факторами. Увеличиваем видимость вашего бизнеса в поисковых системах.',
    meta: 'seo · аудит · рост трафика',
  },
  {
    href: '/services/yandex-maps/',
    number: '05 / карты',
    title: 'Продвижение в Яндекс.Картах',
    description:
      'Выводим карточку компании в локальную выдачу, работаем с геозапросами, репутацией и конверсией из карт.',
    meta: 'локальный спрос · карты · заявки',
  },
  {
    href: '/services/websites/redesign-support/',
    number: '06 / саппорт',
    title: 'Редизайн и поддержка',
    description:
      'Полное сопровождение проектов: техническая поддержка, обновление и мониторинг. Обеспечиваем стабильную работу ваших решений.',
    meta: 'редизайн · sla · мониторинг',
  },
];

const reasons = [
  {
    title: 'Опыт работы с крупными компаниями',
    description:
      'Наше digital-агентство имеет многолетний опыт работы с бизнесом. Мы понимаем специфику разных отраслей и знаем, какие цифровые решения дают максимальный ROI.',
  },
  {
    title: 'Команда профессионалов digital-студии',
    description:
      'На Вашем проекте работают штатные специалисты высшего класса - от стратегов и аналитиков до senior-разработчиков. Единая команда - гарантия качества и скорости.',
  },
  {
    title: 'Фокус на измеримый результат (ROI)',
    description:
      'Мы не просто создаем цифровые продукты, мы считаем их эффективность. Каждое наше решение подкреплено аналитикой и нацелено на достижение ваших бизнес-показателей.',
  },
  {
    title: 'Прозрачность и полная отчетность',
    description:
      'Вы всегда в курсе этапов работы, расходов и результатов. Мы предоставляем четкие и понятные отчеты, чтобы вы могли видеть ценность каждого вложенного рубля.',
  },
];

const homeReviews = [
  {
    name: 'Максим С., CMO салона премиальной мебели',
    text: [
      'Работали с этим digital агентством по созданию сайта и дальнейшему продвижению. Искали именно агентство полного цикла в Москве, которое возьмет на себя весь процесс: от разработки до маркетинга.',
      'В итоге получили не просто сайт, а полноценное цифровое решение для бизнеса. Команда профессионалов digital студии глубоко погрузилась в задачи проекта, предложила улучшения по UX и помогла выстроить структуру.',
      'Сейчас продолжаем сотрудничество в формате сопровождения и развития проекта.',
    ],
  },
  {
    name: 'Алина Д., владелица сети кальянных в Москве',
    text: [
      'Обращались в веб студию Москва для разработки интернет-проекта под ключ. Был важен комплексный подход: дизайн, разработка и продвижение.',
      'Команда показала себя как профессиональная digital студия с системным подходом. Все этапы от прототипа до запуска были прозрачными. В портфолио digital агентства увидели похожие кейсы, что усилило доверие.',
      'В результате получили современный сайт с высокой скоростью и хорошей конверсией. Сейчас продолжается техническая поддержка и масштабирование проекта.',
      'Однозначно рекомендуем как одно из лучших digital агентств Москвы.',
    ],
  },
  {
    name: 'Артем М., Директор строительной компании',
    text: [
      'Долго выбирали среди топ агентств Москвы и остановились на этой компании. Нужны были комплексные digital решения для бизнеса и цифровая трансформация процессов.',
      'Агентство предложило не просто создание сайта, а полноценную стратегию: разработка, интеграции, аналитика и продвижение. Видно, что это сильное агентство, причем полного цикла с опытом работы в разных нишах.',
      'Отдельно понравилась коммуникация: персональный менеджер всегда на связи, задачи выполняются быстро, правки вносятся оперативно.',
      'Сейчас сайт стабильно приносит заявки.',
    ],
  },
];

const articles = [
  {
    href: '/blog/digital-trends-2024/',
    cover: digitalTrendsCover,
    tag: 'маркетинг',
    date: '03 мая · 8 мин',
    title: 'Топ-5 трендов digital-продвижения в 2026 году',
    label: 'тренды · digital',
    pattern: 'repeating-linear-gradient(45deg,#F4F1EA 0,#F4F1EA 12px,#fff 12px,#fff 24px)',
  },
  {
    href: '/blog/mobile-roi/',
    cover: mobileRoiCover,
    tag: 'мобайл',
    date: '21 апр · 12 мин',
    title: 'Как рассчитать ROI от разработки мобильного приложения для бизнеса',
    label: 'мобайл · roi',
    pattern: 'radial-gradient(circle at 30% 30%,#08D3FF 0%,transparent 35%),#F4F1EA',
    patternOpacity: 0.4,
  },
  {
    href: '/blog/seo-top3/',
    cover: seoTop3Cover,
    tag: 'seo',
    date: '14 апр · 14 мин',
    title: 'Кейс: как мы вывели интернет-магазин в ТОП-3 за 6 месяцев',
    label: 'seo · кейс',
    pattern: 'linear-gradient(135deg,#fff,#F4F1EA)',
  },
];

const faqItems = [
  {
    question: 'В чем преимущество агентства полного цикла?',
    answer:
      'Один подрядчик отвечает за весь жизненный цикл — от стратегии и дизайна до разработки, запуска и продвижения. Это исключает разрывы между командами, сокращает сроки на 25–40% и даёт единую точку ответственности за результат.',
  },
  {
    question: 'Как формируется стоимость разработки и продвижения?',
    answer:
      'После брифа мы декомпозируем задачу по этапам и считаем трудозатраты команды. Стоимость фиксируем в договоре с разбивкой по спринтам. Продвижение — пакетно или по KPI (трафик, позиции, заявки).',
  },
  {
    question: 'Какие гарантии результата вы предоставляете?',
    answer:
      'Гарантия на разработку — 12 месяцев по договору: бесплатное исправление багов и регрессов. По продвижению — KPI по позициям и трафику с регулярной отчётностью. Все обязательства закреплены документально.',
  },
  {
    question: 'Какой опыт работы у вашего агентства с крупным бизнесом?',
    answer:
      'С 2019 года реализовали 200+ проектов для крупных федеральных и региональных компаний из ритейла, финтеха, медицины, промышленности и e-commerce. Кейсы и отзывы — в разделе «Портфолио».',
  },
  {
    question: 'Вы работаете только с Москвой или с регионами тоже?',
    answer:
      'Офис в Москве, но география работы не ограничена. Все процессы выстроены на удалёнке: проекты ведём в Jira, демо — онлайн, отчёты приходят на почту еженедельно. Среди клиентов — 38 регионов России.',
  },
];

function SectionHeader({ eyebrow, children, description, dark = false }) {
  return (
    <div className={`sec-head${dark ? ' ink-head' : ''}`}>
      <div>
        <div className={`eyebrow${dark ? ' cyan' : ''}`}>— {eyebrow}</div>
        <h2>{children}</h2>
      </div>
      <p className="sub">{description}</p>
    </div>
  );
}

function HomePage() {
  const [openFaq, setOpenFaq] = useState(0);

  return (
    <RedesignPage>
      <PageMeta
        title="Веб-студия в Москве полного цикла - создание и продвижение сайтов"
        description="Fatality - digital-агентство для бизнеса в Москве и России. Комплексные решения: от разработки сайтов и приложений до цифрового продвижения. Реализовали 200+ проектов. Кейсы, отзывы, команда профессионалов. Рассчитайте стоимость на сайте fatalitystudio.ru или по телефону +7 (925) 653-04-54 !"
      />
      <RedesignHeader />

      <section className="ink hero" data-screen-label="01 hero">
        <div
          className="glow"
          style={{ right: '-360px', top: '-360px', width: '1000px', height: '1000px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="eyebrow cyan">— since 2019 · москва · digital-агентство полного цикла</div>
          <h1>
            Digital-агентство полного цикла в <span className="accent">Москве</span>
          </h1>
          <p className="hero-sub">
            Профессиональная веб-студия с опытом работы с крупными компаниями.{' '}
            <b>Комплексная разработка и продвижение проектов под ключ</b> — от создания сайтов и приложений до их
            результативного цифрового сопровождения.
          </p>
          <div className="hero-ctas">
            <a href="#lead" className="btn btn-primary">
              начать проект →
            </a>
            <SiteLink href="/calculator/" className="btn btn-ghost-dark">
              рассчитать стоимость
            </SiteLink>
          </div>

          <div className="hero-meta">
            <div>
              <div className="num">
                7<span>+</span>
              </div>
              <div className="lbl">лет на рынке · с 2019</div>
            </div>
            <div>
              <div className="num">
                200<span>+</span>
              </div>
              <div className="lbl">проектов в проде</div>
            </div>
            <div>
              <div className="num">
                10<span>+</span>
              </div>
              <div className="lbl">штатных специалистов</div>
            </div>
            <div>
              <div className="num">
                24<span>/</span>7
              </div>
              <div className="lbl">саппорт после релиза</div>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad" id="services" data-screen-label="02 services">
        <div className="container">
          <SectionHeader
            eyebrow="что делаем"
            description="Профессиональное digital-агентство предлагает полный спектр услуг для вашего бизнеса. От создания и продвижения до технического сопровождения — мы реализуем проекты любой сложности."
          >
            Услуги digital-агентства: <span className="accent">комплексные</span> решения под ключ
          </SectionHeader>

          <div className="svc-grid">
            {services.map((service) => (
              <SiteLink href={service.href} className="svc" key={service.title}>
                <div className="svc-top">
                  <span className="svc-num">{service.number}</span>
                  <span className="svc-arrow">↗</span>
                </div>
                <h3>{service.title}</h3>
                <p className="svc-desc">{service.description}</p>
                <div className="svc-meta">{service.meta}</div>
              </SiteLink>
            ))}
          </div>
          <div className="section-action-row">
            <SiteLink href="/services/vseuslugi/" className="btn btn-primary">
              Все услуги
            </SiteLink>
          </div>
        </div>
      </section>

      <section className="ink sec-pad" id="why" data-screen-label="03 why">
        <div
          className="glow"
          style={{ left: '-280px', top: '-280px', width: '700px', height: '700px', opacity: 0.08 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <SectionHeader
            dark
            eyebrow="преимущества"
            description="Четыре принципа, по которым нас находят и с которыми остаются на годы. Без маркетингового тумана — только то, что закреплено в договоре."
          >
            Почему выбирают наше <span className="accent">digital-агентство</span>
          </SectionHeader>

          <div className="why-grid">
            {reasons.map((reason, index) => (
              <div className="why" key={reason.title}>
                <div className="why-n">{String(index + 1).padStart(2, '0')}</div>
                <h3>{reason.title}</h3>
                <p className="why-d">{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="canvas sec-pad" id="cases" data-screen-label="04 cases">
        <div className="container">
          <SectionHeader
            eyebrow="портфолио"
            description="Оцените примеры работ и успешные кейсы нашей веб-студии. Мы гордимся каждым проектом, который помог нашим клиентам укрепить позиции на рынке."
          >
            Кейсы агентства: успешные <span className="accent">проекты</span> и портфолио веб-студии
          </SectionHeader>

          <div className="case-spot">
            <div className="case-visual case-image-preview">
              <TelStoreCover preview alt="Кейс TelStore — интернет-магазин и CRM" />
              <span className="case-visual-tag">e-commerce + crm</span>
              <div className="case-visual-meta">2026 · Магазин техники · Москва</div>
            </div>
            <div className="case-body">
              <div className="eyebrow">— кейс месяца</div>
              <div className="case-title">Создание интернет-магазина техники в Москве: с 0 до 100+ заказов в месяц</div>
              <dl>
                <div>
                  <dt>Клиент</dt>
                  <dd>Интернет-магазин премиальной техники в Москве</dd>
                </div>
                <div>
                  <dt>Задача</dt>
                  <dd>Увеличить онлайн-продажи и автоматизировать заказы</dd>
                </div>
                <div>
                  <dt>Решение</dt>
                  <dd>
                    Разработан интернет-магазин с глубокой интеграцией в CRM-систему и сервисы доставки, 4 месяца
                    SEO-оптимизации, разработка чат-бот в Telegram
                  </dd>
                </div>
                <div style={{ borderBottom: 0 }}>
                  <dt>Результат</dt>
                  <dd>
                    <b>Рост органического трафика на 40% за 3 месяца</b>, запуск рекламы - средняя цена клика 125
                    рублей, высокая конверсия.
                  </dd>
                </div>
              </dl>
              <SiteLink href="/portfolio/" className="link-flat" style={{ marginTop: '8px' }}>
                все кейсы — 200+ проектов →
              </SiteLink>
            </div>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad" style={{ paddingTop: 0 }} data-screen-label="05 trust">
        <div className="container">
          <div className="sec-head" style={{ borderTop: '1px solid var(--line-light)', paddingTop: '120px' }}>
            <div>
              <div className="eyebrow">— нам доверяют</div>
              <h2>
                Нам <span className="accent">доверяют</span>: отзывы клиентов агентства
              </h2>
            </div>
          </div>

          <ReviewsCarousel className="home-reviews-grid">
            {homeReviews.map((review, index) => (
              <figure className="home-review-card" key={review.name}>
                <div className="review-index">{String(index + 1).padStart(2, '0')}</div>
                <blockquote>
                  {review.text.map((paragraph) => (
                    <p key={paragraph}>{paragraph}</p>
                  ))}
                </blockquote>
                <ReviewAuthor label={review.name} />
              </figure>
            ))}
          </ReviewsCarousel>
        </div>
      </section>

      <section className="canvas sec-pad geo" style={{ paddingTop: 0 }} data-screen-label="06 geo">
        <div className="container">
          <div
            className="sec-head"
            style={{ borderTop: '1px solid var(--line-light)', paddingTop: '120px', marginBottom: '48px' }}
          >
            <div>
              <div className="eyebrow">— география</div>
              <h2>
                Digital-агентство в Москве и <span className="accent">по всей России</span>
              </h2>
            </div>
            <p className="sub">
              Мы - цифровое агентство в Москве, но наша география работы не ограничена. Благодаря отлаженным процессам
              удаленного взаимодействия, мы успешно реализуем проекты для клиентов из всех регионов России.
            </p>
          </div>

          <div className="geo-grid">
            <div>
              <div className="geo-stats">
                <div>
                  <div className="num">38</div>
                  <div className="lbl">регионов · клиенты</div>
                </div>
                <div>
                  <div className="num">100%</div>
                  <div className="lbl">проектов · удалённо</div>
                </div>
                <div>
                  <div className="num">+3</div>
                  <div className="lbl">мск · часовых поясов</div>
                </div>
                <div>
                  <div className="num">24/7</div>
                  <div className="lbl">связь · tg, email, jira</div>
                </div>
              </div>
            </div>
            <GeographyMap />
          </div>
        </div>
      </section>

      <section className="canvas sec-pad" id="blog" style={{ paddingTop: 0 }} data-screen-label="07 blog">
        <div className="container">
          <div className="sec-head" style={{ borderTop: '1px solid var(--line-light)', paddingTop: '120px' }}>
            <div>
              <div className="eyebrow">— блог</div>
              <h2>
                Полезные материалы от <span className="accent">профессионалов</span> IT-индустрии
              </h2>
            </div>
            <p className="sub">Разборы, гайды и кейсы нашей команды. Без воды — только то, что мы сами проверили на проде.</p>
          </div>

          <div className="blog-grid">
            {articles.map((article) => (
              <SiteLink href={article.href} className="article" key={article.href}>
                <div className="article-img">
                  {article.cover ? (
                    <img src={article.cover} alt="" width="1800" height="1200" loading="lazy" decoding="async" />
                  ) : (
                    <>
                      <div
                        className="article-img-pat"
                        style={{ background: article.pattern, opacity: article.patternOpacity }}
                      />
                      <span className="ph">{article.label}</span>
                    </>
                  )}
                </div>
                <div className="article-meta">
                  <span className="article-tag">{article.tag}</span>
                  <span>{article.date}</span>
                </div>
                <h3 className="article-title">{article.title}</h3>
              </SiteLink>
            ))}
          </div>

          <div style={{ marginTop: '48px', textAlign: 'center' }}>
            <SiteLink href="/blog/" className="link-flat">
              все статьи блога →
            </SiteLink>
          </div>
        </div>
      </section>

      <section className="canvas sec-pad" id="faq" style={{ paddingTop: 0 }} data-screen-label="08 faq">
        <div className="container">
          <div className="sec-head" style={{ borderTop: '1px solid var(--line-light)', paddingTop: '120px' }}>
            <div>
              <div className="eyebrow">— faq</div>
              <h2>
                Часто задаваемые <span className="accent">вопросы</span> об услугах веб-студии
              </h2>
            </div>
            <p className="sub">
              Мы очень старались расписать все подробно, но если Вы не нашли ответ на свой вопрос на странице нашего
              сайта - напишите в форму ниже или в Telegram/Max. Ответим в течение часа.
            </p>
          </div>

          <div className="faq-list faq-list-wide" id="faq-list">
              {faqItems.map((item, index) => {
                const isOpen = openFaq === index;
                return (
                  <div className={`faq-item${isOpen ? ' open' : ''}`} key={item.question}>
                    <button className="faq-q" type="button" onClick={() => setOpenFaq(isOpen ? -1 : index)}>
                      <span>{item.question}</span>
                      <span className="faq-toggle">+</span>
                    </button>
                    <div className="faq-a">
                      <div className="faq-a-inner">{item.answer}</div>
                    </div>
                  </div>
                );
              })}
          </div>
        </div>
      </section>

      <section className="ink lead" id="lead" data-screen-label="09 lead">
        <div
          className="glow"
          style={{ left: '-300px', top: '-200px', width: '700px', height: '700px', opacity: 0.1 }}
        />
        <div className="container" style={{ position: 'relative' }}>
          <div className="lead-grid">
            <div className="lead-side">
              <div className="eyebrow cyan">— связаться</div>
              <h2>
                Начните проект уже&nbsp;
                <span
                  style={{
                    background: 'linear-gradient(135deg,#08FFFC,#08D3FF)',
                    WebkitBackgroundClip: 'text',
                    backgroundClip: 'text',
                    color: 'transparent',
                  }}
                >
                  сегодня
                </span>
              </h2>
              <p className="lead-text">
                Готовы начать успешный проект? Оставьте заявку и получите бесплатную консультацию от ведущей веб-студии
                Москвы с анализом вашего бизнеса и предложением по его развитию.
              </p>

              <div className="lead-promise">
                <div className="promise">
                  <div className="promise-n">01</div>
                  <div>
                    <div className="promise-t">Отвечаем в течение часа</div>
                    <div className="promise-d">в рабочее время — пн–пт, 10:00–19:00 мск</div>
                  </div>
                </div>
                <div className="promise">
                  <div className="promise-n">02</div>
                  <div>
                    <div className="promise-t">Бесплатная консультация</div>
                    <div className="promise-d">анализ задачи + предложение по развитию бизнеса</div>
                  </div>
                </div>
                <div className="promise">
                  <div className="promise-n">03</div>
                  <div>
                    <div className="promise-t">NDA по запросу</div>
                    <div className="promise-d">данные не передаём третьим лицам · храним по 152-фз</div>
                  </div>
                </div>
              </div>
            </div>

            <LeadForm />
          </div>
        </div>
      </section>

      <RedesignFooter />
    </RedesignPage>
  );
}

export default HomePage;
